import { useState, useContext, Fragment } from 'react';
import { UserContext } from 'context/UserContext';
import Flag from 'components/molecules/Flag';
import { Link } from 'react-router-dom';
import { AiOutlineDelete, AiFillApi } from 'react-icons/ai';
import { GoArchive } from 'react-icons/go';
import { FaTimes } from 'react-icons/fa';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { IconButton } from '@mui/material';
import vDots from 'components/DropDowns/three-dots-vertical.svg';

function ArchivedCourses({ data = {}, setActions, modeOfView }) {
  const { result } = data;
  const { userPermissions = {} } = useContext(UserContext);

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <h1 className="prime-head forSlider">Archived Courses</h1>
      {result?.length > 0 ? (
        <div className="slider">
          {modeOfView === 'grid' && (
            <div className="sliderSec">
              {result?.map?.((course) => {
                return (
                  <div className="sliderSec-box" key={course._id}>
                    <img
                      className="sliderSec-boxImg"
                      src={course.courseImageUrlFull || 'https://picsum.photos/300/400'}
                      alt={course.courseName}
                    />
                    <div className="sliderSec-boxHead">
                      <h2>{course.courseName}</h2>
                    </div>
                    <div className="sliderSec-boxBtns flex-wrap">
                      {course?.classId?.name && (
                        <button className="btn-plane">{course.classId.name}</button>
                      )}
                      {course?.es?.name && (
                        <button className="my-1 btn-plane green">{course.es.name}</button>
                      )}
                      {course?.est?._id && <Flag id={course.est.key} name={course.est.name} />}
                    </div>
                    <div className="sliderSec-boxMore">
                      <>
                        <IconButton aria-label="basic-menu" size="small" onClick={handleClick}>
                          <img src={vDots} alt="Click to select options" />
                        </IconButton>
                        <Menu
                          id="basic-menu"
                          className="__grid_courses__menu"
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          MenuListProps={{
                            'aria-labelledby': 'basic-button',
                          }}
                        >
                          <MenuItem disabled>Actions</MenuItem>
                          <MenuItem
                            onClick={() => {
                              userPermissions?.course?.actOnDotsbuttonTile
                                ? setActions({
                                    open: true,
                                    data: { status: 'draft', id: course._id },
                                    Header: 'Draft mode',
                                    Body: 'Do you want to change this course to draft mode?',
                                    isDeleteOperation: false,
                                  })
                                : alert('You dont have sufficient permission to make this change.');

                              handleClose();
                            }}
                          >
                            <AiFillApi className="mr-2" /> Draft
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              userPermissions?.course?.actOnDotsbuttonTile
                                ? setActions({
                                    open: true,
                                    data: { status: 'deactivate', id: course.id },
                                    Header: 'Deactivate course',
                                    Body: 'Do you want to deactivate this course?',
                                    isDeleteOperation: false,
                                  })
                                : alert('You dont have sufficient permission to make this change.');

                              handleClose();
                            }}
                          >
                            <FaTimes className="mr-2" /> Deactivate
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              userPermissions?.course?.actOnDotsbuttonTile
                                ? setActions({
                                    open: true,
                                    data: { status: 'active', id: course.id },
                                    Header: 'Unarchive & Activate course',
                                    Body: 'Do you want to make this course active?',
                                    isDeleteOperation: false,
                                  })
                                : alert('You dont have sufficient permission to make this change.');

                              handleClose();
                            }}
                          >
                            <GoArchive className="mr-2" /> Unarchive
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              userPermissions?.course?.actOnDotsbuttonTile
                                ? setActions({
                                    open: true,
                                    data: { status: 'delete', id: course.id },
                                    Header: 'Delete Course',
                                    Body: 'Do you want to delete this course?',
                                    isDeleteOperation: true,
                                  })
                                : alert('You dont have sufficient permission to make this change.');

                              handleClose();
                            }}
                          >
                            <AiOutlineDelete className="mr-2" /> Delete
                          </MenuItem>
                        </Menu>
                      </>

                      <Link to={`/courses/${course._id}/edit`}>
                        <button className="btn-right-content tool">Manage</button>
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {modeOfView === 'table' && (
            <div className="table-responsive">
              <table className="table tableWrap__table">
                <thead className="thead-light __appTheadColor">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col"></th>
                    <th scope="col" className="w15">
                      Name
                    </th>

                    <th scope="col" className="w15">
                      Class
                    </th>
                    <th scope="col" className="w15">
                      Board
                    </th>
                    <th scope="col" className="w15">
                      Country
                    </th>

                    <th scope="col" className="align-center">
                      Actions
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {result?.map?.((course, index) => {
                    return (
                      <Fragment>
                        <tr key={course._id}>
                          <th scope="row">{index + 1}</th>
                          <th>
                            <img
                              className="listsliderSec-boxImg sliderSec-boxImg"
                              src={course.courseImageUrlFull || 'https://picsum.photos/300/400'}
                              alt={course.courseName}
                              style={{ border: '1px solid #de6cef' }}
                            />
                          </th>
                          <td>{course.courseName}</td>
                          <td>
                            {course?.classId?.name && (
                              <button className="btn-plane">{course.classId.name}</button>
                            )}
                          </td>
                          <td>
                            {course?.es?.name && (
                              <button className="my-1 btn-plane green">{course.es.name}</button>
                            )}
                          </td>
                          <td>
                            {course?.est?._id && (
                              <Flag id={course.est.key} name={course.est.name} />
                            )}
                          </td>
                          <td>
                            <div className="sliderSec-boxMore">
                              <>
                                <IconButton
                                  aria-label="basic-menu"
                                  size="small"
                                  onClick={handleClick}
                                >
                                  <img src={vDots} alt="Click to select options" />
                                </IconButton>
                                <Menu
                                  id="basic-menu"
                                  className="__grid_courses__menu"
                                  anchorEl={anchorEl}
                                  open={open}
                                  onClose={handleClose}
                                  MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                  }}
                                >
                                  <MenuItem disabled>Actions</MenuItem>
                                  <MenuItem
                                    onClick={() => {
                                      userPermissions?.course?.actOnDotsbuttonTile
                                        ? setActions({
                                            open: true,
                                            data: { status: 'draft', id: course._id },
                                            Header: 'Draft mode',
                                            Body: 'Do you want to change this course to draft mode?',
                                            isDeleteOperation: false,
                                          })
                                        : alert(
                                            'You dont have sufficient permission to make this change.'
                                          );

                                      handleClose();
                                    }}
                                  >
                                    <AiFillApi className="mr-2" /> Draft
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() => {
                                      userPermissions?.course?.actOnDotsbuttonTile
                                        ? setActions({
                                            open: true,
                                            data: { status: 'deactivate', id: course.id },
                                            Header: 'Deactivate course',
                                            Body: 'Do you want to deactivate this course?',
                                            isDeleteOperation: false,
                                          })
                                        : alert(
                                            'You dont have sufficient permission to make this change.'
                                          );

                                      handleClose();
                                    }}
                                  >
                                    <FaTimes className="mr-2" /> Deactivate
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() => {
                                      userPermissions?.course?.actOnDotsbuttonTile
                                        ? setActions({
                                            open: true,
                                            data: { status: 'active', id: course.id },
                                            Header: 'Unarchive & Activate course',
                                            Body: 'Do you want to make this course active?',
                                            isDeleteOperation: false,
                                          })
                                        : alert(
                                            'You dont have sufficient permission to make this change.'
                                          );

                                      handleClose();
                                    }}
                                  >
                                    <GoArchive className="mr-2" /> Unarchive
                                  </MenuItem>
                                  <MenuItem
                                    onClick={() => {
                                      userPermissions?.course?.actOnDotsbuttonTile
                                        ? setActions({
                                            open: true,
                                            data: { status: 'delete', id: course.id },
                                            Header: 'Delete Course',
                                            Body: 'Do you want to delete this course?',
                                            isDeleteOperation: true,
                                          })
                                        : alert(
                                            'You dont have sufficient permission to make this change.'
                                          );

                                      handleClose();
                                    }}
                                  >
                                    <AiOutlineDelete className="mr-2" /> Delete
                                  </MenuItem>
                                </Menu>
                              </>

                              <Link to={`/courses/${course._id}/edit`}>
                                <button className="btn-right-content tool">Manage</button>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      </Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      ) : (
        <div>No records found</div>
      )}
    </>
  );
}

export default ArchivedCourses;
